import { useEffect, useRef } from 'react';
import { ORG_CONFIGS } from '../config/storeConfig';
import { useStoreState } from '../store';

declare const window: Window & {
  dataLayer: any[];
  gtag: (...args: any) => void;
};

export const useGoogleAnalytics = () => {
  const orgId = useStoreState(state => state.orgContext.orgId);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current || !orgId) return;
    const trackingID = ORG_CONFIGS[orgId]?.googleAnalyticsId;
    if (!trackingID) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingID}`;
    script.async = true;
    document.head.appendChild(script);

    window.gtag('js', new Date());
    window.gtag('config', trackingID);

    initializedRef.current = true;
  }, [orgId]);
};
